import { createContext, useContext, useMemo, useState } from "react";

const generalContext = createContext();

export const styleSjabloon = {
  parameters: {
    alphaMultiplier: 1,

    fill: {
      type: "rangeMap",
      expression: "band1",
      gradient: true,
      rangeMap: [
        { value: 0, target: { type: "color", color: "#0062B1" } },
        {
          value: 11.11111111111111,
          target: { type: "color", color: "#009CE0" },
        },
        {
          value: 22.22222222222222,
          target: { type: "color", color: "#73D8FF" },
        },
        {
          value: 33.33333333333333,
          target: { type: "color", color: "#808900" },
        },
        {
          value: 44.44444444444444,
          target: { type: "color", color: "#A4DD00" },
        },
        {
          value: 55.55555555555556,
          target: { type: "color", color: "#A4DD00" },
        },
        {
          value: 66.66666666666666,
          target: { type: "color", color: "#FCDC00" },
        },
        {
          value: 77.77777777777777,
          target: { type: "color", color: "#FB9E00" },
        },
        {
          value: 88.88888888888889,
          target: { type: "color", color: "#D33115" },
        },
        { value: 100, target: { type: "color", color: "#9F0500" } },
      ],
    },
    shade: {
      factor: 0.4,
      exaggerate: 10,
      angle: 45,
      azimuth: 90,
      bandNumber: 1,
    },
  },

  method: "v2",
  name: "Hoogte",
};

export const GeneralProvider = ({ children }) => {
  const [flyTo, setFlyTo] = useState();
  const [snackbar, setSnackbar] = useState();
  const [dynamicStyle, setDynamicStyle] = useState(null);

  const value = useMemo(
    () => ({
      flyTo,
      setFlyTo,
      snackbar,
      setSnackbar,
      dynamicStyle,
      setDynamicStyle,
    }),
    [flyTo, setFlyTo, snackbar, setSnackbar, dynamicStyle, setDynamicStyle],
  );

  return (
    <generalContext.Provider value={value}>{children}</generalContext.Provider>
  );
};

export const useGeneral = () => {
  const context = useContext(generalContext);

  if (context === undefined) {
    throw new Error("useGeneral must be used within a AnalyseProvider");
  }
  return context;
};
